export default function OffCanvasLoader() {
    return (
        <div className="offcanvas-loader">
            <div className="loader-container">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        </div>
    );   
}